import { User } from '@/model';
import api from '@/rest-api';
import { uniqueIndex } from '@/util/array-util';
import moduleBuilder from './module-builder';
import store from './store';

const usersSorter = (a: User, b: User) => a.displayName.trim().localeCompare(b.displayName.trim());

const users = moduleBuilder()
  .state({
    users: undefined as User[] | undefined,
  })
  .defaultMutations({
    setUsers(state, u: User[]) {
      state.users = u.sort(usersSorter);
    },
  })
  .getters({
    lookup(state) {
      return uniqueIndex(state.users || [], (u) => u.id);
    },
  })
  .actions({
    all(ctx): Promise<User[]> {
      if (ctx.state.users !== undefined) {
        return Promise.resolve(ctx.state.users);
      }
      const p = api.users();
      p.then((u) => ctx.commit('setUsers', u));
      return p;
    },
  })
  .hideMutations()
  .register(store, 'users');

export default users;
